"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LRUQueue = void 0;
class LRUQueue {
    constructor(capacity, getId, onEvict) {
        this.items = [];
        this.capacity = capacity;
        this.getId = getId;
        this.onEvict = onEvict;
    }
    add(item) {
        const index = this.items.findIndex(i => this.getId(i) === this.getId(item));
        if (index !== -1) {
            this.items.splice(index, 1);
        }
        else if (this.items.length === this.capacity) {
            const evicted = this.items.pop();
            this.onEvict(evicted);
        }
        this.items.unshift(item);
    }
    get(id) {
        return this.items.find(i => this.getId(i) === id);
    }
    touch(id) {
        const index = this.items.findIndex(i => this.getId(i) === id);
        if (index === -1) {
            return undefined;
        }
        const [item] = this.items.splice(index, 1);
        this.items.unshift(item);
        return item;
    }
    remove(id) {
        const index = this.items.findIndex(i => this.getId(i) === id);
        if (index === -1) {
            return;
        }
        this.onEvict(this.items[index]);
        this.items.splice(index, 1);
    }
    trim(keepCount) {
        const evicted = this.items.splice(keepCount);
        evicted.forEach(item => this.onEvict(item));
    }
    reset() {
        this.items.forEach(item => this.onEvict(item));
        this.items = [];
    }
    toArray() {
        return [...this.items];
    }
}
exports.LRUQueue = LRUQueue;
